import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 採番方法 */
enum NumberingMethod {
  enterDirectly = '1',
  automaticNumbering = '2',
  notChange = '3',
}

const nameConfig = {
  enterDirectly: new Map([[Locale.ja, '直接入力する']]),
  automaticNumbering: new Map([[Locale.ja, '自動採番する']]),
  notChange: new Map([[Locale.ja, '変更しない']]),
};

const toEnum = rawValueToEnum(NumberingMethod, NumberingMethod.notChange);
const toDisplay = enumToName(NumberingMethod, nameConfig);
const toDisplayWithPrefix = enumToName(NumberingMethod, nameConfig, { prefix: true });

export const numberingMethod = {
  enum: NumberingMethod,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { NumberingMethod };
